<template>
  <div>
    <v-list-item @click="to_request_details(item.id)">
      <v-list-item-icon class="ml-3">
        <v-icon>mdi-eye-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        فتح الطلب
      </v-list-item-title>
    </v-list-item>

    <router-link style="text-decoration: none" target="_blank"
      :to="{ name: 'request_details', params: { id: item.id } }">
      <v-list-item>
        <v-list-item-icon class="ml-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.528" height="15.111" viewBox="0 0 13.528 10.111">
            <g id="Icon_feather-eye-dark" data-name="Icon feather-eye-dark" transform="translate(-1 -5.5)">
              <path id="Path_4040" data-name="Path 4040"
                d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
              <path id="Path_4041" data-name="Path 4041"
                d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                transform="translate(-7.444 -4.653)" fill="none" stroke="#000" stroke-linecap="round"
                stroke-linejoin="round" stroke-width="1" />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title> فتح في تاب جديد</v-list-item-title>
      </v-list-item>
    </router-link>

    <v-list-item
      v-if="account_type == 1 && currentPath === '/accounting/wasata-under-reports' && item.is_approved_by_wsata_acc == 'لا' && item.statusReq != 16 && item.statusReq != 26"
      @click="takeActionOnWsataRequest(item, 'approve')">
      <v-list-item-icon class="ml-2">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#4CAF50" stroke-width="2" fill="#E8F5E8" />
          <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#4CAF50" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </v-list-item-icon>
      <v-list-item-title>إعتماد WS</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="account_type == 1 && currentPath === '/accounting/wasata-under-reports' && item.is_approved_by_wsata_acc == 'نعم' && item.statusReq != 16 && item.statusReq != 26"
      @click="takeActionOnWsataRequest(item, 'reapprove')">
      <v-list-item-icon class="ml-2">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#FF9800" stroke-width="2" fill="#FFF3E0" />
          <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#FF9800" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M16 8L18 6M18 6L20 8M18 6V10" stroke="#FF9800" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </v-list-item-icon>
      <v-list-item-title>التراجع عن الاعتماد Ws</v-list-item-title>
    </v-list-item>


    <v-list-item
      v-if="account_type == 0 && currentPath === '/accounting/tsaheel-under-reports' && item.is_approved_by_tsaheel_acc == 'لا' && item.statusReq != 16 && item.statusReq != 26"
      @click="takeActionOnWsataRequest(item, 'approve')">
      <v-list-item-icon class="ml-2">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#4CAF50" stroke-width="2" fill="#E8F5E8" />
          <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#4CAF50" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </v-list-item-icon>
      <v-list-item-title>إعتماد TS</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="account_type == 0 && currentPath === '/accounting/tsaheel-under-reports' && item.is_approved_by_tsaheel_acc == 'نعم' && item.statusReq != 16 && item.statusReq != 26"
      @click="takeActionOnWsataRequest(item, 'reapprove')">
      <v-list-item-icon class="ml-2">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#FF9800" stroke-width="2" fill="#FFF3E0" />
          <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#FF9800" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M16 8L18 6M18 6L20 8M18 6V10" stroke="#FF9800" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </v-list-item-icon>
      <v-list-item-title>التراجع عن الاعتماد TS</v-list-item-title>
    </v-list-item>

  </div>
</template>

<script>
import { OrderHistory } from "@/assets/adminIcons/orderHistory";
import { axiosInstance } from "@/axios/config";

export default {
  components: {
  },
  props: ["item"],
  data() {
    return {
      label: "",
      message: "",
      account_type: localStorage.getItem('account_type')
    };
  },
  computed: {
    returnAllRequests() {
      return this.allStatus;
    },

    currentPath() {
      return this.$route.path;
    }
  },
  methods: {
    to_request_details(item) {
      if (localStorage["role"] && localStorage["role"] == "1") {
        this.$router.push({
          name: "salesManager_request_details",
          params: { id: item },
        });
      } else {
        this.$router.push({
          name: "request_details",
          params: { id: item },
        });
      }
    },

    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.id } });
    },

    getRequestCalls(item) {
      this.$store.state.idOfRequestCalls = item.id;
      this.$store.state.openCallsDialog = true;
    },

    toOrderRequest(item) {
      this.$store.state.orderRequestId = item.id;
      if (this.$store.state.showCards || this.$store.state.showCards == false) {
        this.$store.state.orderRequestDialog = true;
      } else {
        this.$store.state.openOrderRequestSection = true;
      }
    },
    takeActionOnWsataRequest(item, $type) {
      let url = '';
      if (this.account_type == 1) {
        url = $type == 'approve' ? '/employee/accounting/approvewsatareq' : '/employee/accounting/reapprovewsatareq';
      } else {
        url = $type == 'approve' ? '/employee/accounting/approvetsaheelreq' : '/employee/accounting/reapprovetsaheelreq';
      }
      axiosInstance.get(`${url}/${item.id}`).then((response) => {
        this.$emit('reloadData');
      });
    },
  },
};
</script>
